import React from 'react';
import { replaceAttrSpaceWithHyphen } from '../../../utils/string-helpers/replace-attr-space-with-hyphen';
import { IOption } from '../../../models/checkbox/IOption';
import styles from './checkbox.module.scss';
import IconTooltip from '../../molecules/icon-tooltip/icon-tooltip';
import { InfoIcon } from '../icons/icons';
import Markdown from 'markdown-to-jsx';
import colorStyle from '../../../styles/utils/variables.module.scss';

type Props = {
  filterOption: IOption;
  onChange?: (option: IOption) => void;
};

export default function Checkbox({ filterOption, onChange }: Props) {
  function handleChange() {
    if (onChange) {
      const changes = {
        text: filterOption.text,
        name: filterOption.name,
        parentName: filterOption.parentName,
        id: filterOption.id,
        selected: !filterOption.selected,
      };
      onChange(changes);
    }
  }

  return (
    <>
      <input
        type='checkbox'
        id={replaceAttrSpaceWithHyphen(filterOption.parentName+' '+filterOption.id)}
        name={filterOption.parentName+'-'+filterOption.name}
        className={`${styles.checkbox}`}
        checked={filterOption.selected || false}
        onChange={handleChange}
        disabled={filterOption.disabled}
        hidden={filterOption.hideOption}
      />
      <label
        id={`${filterOption.id}`}
        data-insights-filter={`${filterOption.parentName}:${filterOption.id}`}
        className={`
        ${filterOption.disabled ? `${styles[`label-disabled`]}` : ``}`}
        htmlFor={replaceAttrSpaceWithHyphen(filterOption.parentName+' '+filterOption.id)}
        hidden={filterOption.hideOption}
      >
        <span className={`${filterOption.hideLabel ? `visually-hidden` : ``}`}>
          {filterOption.text}
        </span>
      </label>
      {filterOption.infoPopupHeading && !filterOption?.hideOption && (
        <IconTooltip
          svgIcon={InfoIcon()}
          svgIconColor={colorStyle.blue100}
          activeSVGIconColor={colorStyle.blue200}
          tooltipAccessibilityLabel={filterOption.name}
          heading={filterOption.infoPopupHeading}
          helperClass={`${styles[`info-icon`]} ms-2`}
        >
          <Markdown>{filterOption.infoPopupDescription}</Markdown>
        </IconTooltip>
      )}
    </>
  );
}
